module.exports = __webpack_public_path__ + "img/Dai-mc3-cb4.a02f0de0.png";